import * as React from 'react';

import classnames from 'classnames';

import type {TodoPeriodSegment} from './todo-list-controls';

import styles from './control-button.module.css';

type Props = {
    name: TodoPeriodSegment;
    label: string;
    onSelect: (activeSegment: TodoPeriodSegment) => void;
    isSelected: boolean;
    hasOverdue?: boolean;
    count: number;
};

export class ControlButton extends React.PureComponent<Props> {
    render() {
        const styleList = classnames({
            [styles['todo-header-date-bucket']]: true,
            [styles['todo-header-date-bucket--selected']]: this.props.isSelected,
            [styles['todo-header-date-bucket--disabled']]: !this.props.count,
        });

        return (
            <div onClick={this.handleClick} className={styleList}>
                <div className={styles.label}>
                    <span className={styles.text}>{this.props.label}</span>
                    <span
                        className={this.props.hasOverdue ? styles['count--overdue'] : styles.count}
                    >
                        {this.props.count}
                    </span>
                </div>
            </div>
        );
    }

    handleClick = () => {
        if (this.props.count) {
            this.props.onSelect(this.props.name);
        }
    };
}
